export const coordinatesValidationHelper = (coordinate: string) => {
	coordinate = coordinate.toString().replace(/[^0-9\.\-]/g, '');
	if (coordinate.replace(/[^\.]/g, '').length > 1) {
		const decimalPointIndex = coordinate.indexOf('.');
		const coordinateDecimals = coordinate.slice(decimalPointIndex);
		coordinate =
			coordinate.slice(0, decimalPointIndex + 1) + coordinateDecimals.replace(/[\.]/g, '');
		if (coordinate.slice(coordinate.length - 1) === '.') {
			coordinate = coordinate.slice(0, coordinate.length - 1);
		}
	}

	if (coordinate.slice(0, 1) === '-') {
		if (coordinate.replace(/[^\-]/g, '').length > 1) {
			coordinate = '-' + coordinate.slice(1).replace(/[\-]/g, '');
		}
	} else {
		if (coordinate.replace(/[^\-]/g, '').length > 0) {
			coordinate = coordinate.replace(/[\-]/g, '');
		}
	}

	return coordinate;
};
